import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import Home from './pages/Home';
import About from './pages/About';
import Teachings from './pages/Teachings';
import Dosage from './pages/Dosage';
import Prayer from './pages/Prayer';
import Events from './pages/Events';
import Contact from './pages/Contact';
import Materials from './pages/Materials';
import Audio from './pages/Audio';
import Archive from './pages/Archive';
import Admin from './pages/Admin';
import SermonSeries from './pages/SermonSeries';

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App bg-ivory">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/teachings" element={<Teachings />} />
            <Route path="/teachings/series/:slug" element={<SermonSeries />} />
            <Route path="/audio" element={<Audio />} />
            <Route path="/dosage" element={<Dosage />} />
            <Route path="/prayer" element={<Prayer />} />
            <Route path="/events" element={<Events />} />
            <Route path="/materials" element={<Materials />} />
            <Route path="/archive" element={<Archive />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
        <FloatingWhatsApp />
      </BrowserRouter>
    </div>
  );
}

export default App;
